import React, { Component } from "react";

import { states } from "../../../reducers/queriesStates";
import { withServiceHistory } from "../../../shared/containers/contaynerServiceHistory";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";

import Scrollbars from "react-custom-scrollbars-2";
import CmsHistoryCommentaryCounter from "./CmsHistoryCommentaryCounter";
import CmsHistoryCommentaryItem from "./CmsHistoryCommentaryItem";
import getDates from "../../../shared/services/date.service";
import styles from "./cmsHistory.module.scss";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { withDevices } from "../../../shared/containers/containerDevices";

class CmsHistoryAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenComments: false,
      commentariesCount: props.action.commentariesCount,
    };
  }

  componentDidMount() {
    const { serviceHistoryActionsDataState, onGetServiceHistoryActions } = this.props;

    if (serviceHistoryActionsDataState !== states.READY) {
      onGetServiceHistoryActions();
    }
  }

  componentDidUpdate(prevProps) {
    const { createServiceHistoryCommentDataState, action, serviceHistory } = this.props;
    const { commentariesCount } = this.state;

    if (createServiceHistoryCommentDataState === states.READY && prevProps.createServiceHistoryCommentDataState === states.REQUEST) {
      serviceHistory.actions.forEach((element) => {
        if (element.id === action.id && commentariesCount !== element.commentariesCount) {
          this.setState({ commentariesCount: element.commentariesCount });
          window.document.getElementById(action.id + "_input").value = null;
        }
      });
    }
  }

  getDeviceType(value) {
    const { protocolMarkers } = this.props;

    return protocolMarkers === null ? "" : protocolMarkers.protocolMarkers.filter((x) => x.value === value)[0].title;
  }

  onSetComment(e) {
    const { action, onCreateServiceHistoryComment } = this.props;
    const input = window.document.getElementById(action.id + "_input");

    if (input.value !== null && input.value !== "") {
      onCreateServiceHistoryComment(action.id, { id: action.id, commentary: input.value });
    }
  }

  getActionTitle(action) {
    const { serviceHistoryActions } = this.props;

    return serviceHistoryActions.filter((x) => {
      return x.value === action;
    })[0].title;
  }

  render() {
    const { action } = this.props;
    const { isOpenComments, commentariesCount } = this.state;

    return (
      <div>
        <div className={styles.cmsHistoryActionItem}>
          <div className={styles.cmsHistoryActionDate}>
            <div className={styles.cmsHistoryActionDateTime}>
              <b>{getDates.getDateFormat9(new Date(Date.parse(action.date + "Z")))}</b>
            </div>
            <div>{this.getActionTitle(action.action)}</div>
          </div>
          <div>
            <TooltipWrapper title={"Пользователь"} position="top">
              <div> {action.user.title}</div>
            </TooltipWrapper>

            <div>{action.user.email}</div>
          </div>
          <div>
            <TooltipWrapper title={"Перенесен из компании " + action.company.title} position="top">
              <div> {action.company.title}</div>
            </TooltipWrapper>
            <TooltipWrapper title={"Перенесен в компанию " + action.toCompany.title} position="top">
              <div>
                <b>{action.toCompany.title}</b>
              </div>
            </TooltipWrapper>
          </div>
          <div>
            <TooltipWrapper title={`Снят с ТС: ${action.unit.title} ${action.unit.registerNumber}`} position="top">
              <div>
                {action.unit.title} {action.unit.registerNumber}
              </div>
            </TooltipWrapper>
            <TooltipWrapper title={`Поставлен на ТС: ${action.toUnit.title} ${action.toUnit.registerNumber}`} position="top">
              <div>
                <b>
                  {action.toUnit.title} {action.toUnit.registerNumber}
                </b>
              </div>
            </TooltipWrapper>
          </div>
          <div>
            <TooltipWrapper title={`Устройство: ${action.device.imei} ${action.toDevice.model}`} position="top">
              <div>
                {action.device.imei} {this.getDeviceType(action.device.type)} {action.toDevice.model}
              </div>
            </TooltipWrapper>
            <TooltipWrapper
              title={`На устройство: ${action.toDevice.imei} ${this.getDeviceType(action.toDevice.type)} ${action.toDevice.model}`}
              position="top"
            >
              <div>
                <b>
                  {action.toDevice.imei} {this.getDeviceType(action.toDevice.type)} {action.device.model}
                </b>
              </div>
            </TooltipWrapper>
          </div>
          <CmsHistoryCommentaryCounter
            onHandleClock={() => {
              this.setState({ isOpenComments: !isOpenComments });
            }}
            count={commentariesCount}
            color={isOpenComments ? "#4da1ff" : null}
          />
        </div>
        {isOpenComments ? (
          <div className={styles.cmsHistoryCommentariesContainer}>
            <Scrollbars ref="scrollbar" style={{ height: "250px" }} autoHide={false}>
              {action.commentaries.map((item) => {
                return <CmsHistoryCommentaryItem item={item} />;
              })}
            </Scrollbars>
            <div className={styles.cmsHistoryCommentaryInput}>
              <textarea id={action.id + "_input"} style={{ width: "100%" }} rows={3} />
              <ButtonPrimary handleClick={this.onSetComment.bind(this)} title="Оставить комментарий" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withServiceHistory(withDevices(CmsHistoryAction));
